<template>
    <div class="detail_page">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <div class='herder'>
                <span class='back' @click="clickBack"><i></i></span>
                <p>查看完成情况</p>
            </div>
            <div class="title"><i class="icon" ></i>{{ unit_name }}-{{ sid == 51 ? '语文' :
                '数学' }}暑假作业</div>
            <div class="stu_list" v-if="stu_data.length">
                <div class="item" v-for="(item,index) in stu_data" :key="index">
                    <div class="name">
                        <img :src="item.portrait" class="avatar">
                        <p>{{item.name }}</p>
                    </div>
                    <div class="test_list" v-if="item.has_join">
                        <div class="test_item" v-for="(item2,index2) in item.data" :key="index2">
                            <strong>{{item2.finish }}/{{item2.total }}</strong>
                            <p>{{ typeList[item2.type] }}</p>
                        </div>
                    </div>
                    <div class="no_join" v-else>暂未开启暑假作业 </div>
                </div>
            </div>
            <noResouse v-else></noResouse>
            <div class="fixed_bottom">
                <span class="share_btn" @click="share">分享班级完成情况</span>
            </div>
            <!-- H5分享页 -->
            <div class="active-rule-bg" v-if="showShare">
                <div class="rule-content share-box">
                    <div class="share_content">
                        <img src="./img/icon_link.png" alt=" " />
                        <strong>链接已复制</strong>
                        <p><span>{{ unit_name }}</span>暑假作业完成情况链接已复制， 在班级群的输入框进行粘贴，然后点击 发送即可。</p>
                        <span class="btn" @click="shareClose">确定</span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import loadings from "COMPONENTS/base/loadingS.vue";
import noResouse from "COMPONENTS/noResouse.vue";
export default {
    components: {
        loadings, noResouse
    },
    data () {
        return {
            summer_year: this.$route.query.summer_year||0,
            loading: false,
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            showShare: false,
            sid: this.$route.params.sid,
            unit_name: '班级',
            unit_class_id: this.$route.params.unit_class_id,
            stu_data:[],
            wap_id:null,
            typeList: ["", "查漏补缺", "拔高训练", "识字与写字", "表达与交流", "梳理与探究", "阅读能力", "综合练习", "新课预习"],
            copyValue: '',//分享链接
        }
    },
    created () {
        window.document.title = `${this.sid==51?'语文':'数学'}-完成情况`,
        this.getData()
    },
    methods: {
        clickBack () {
            this.$router.go(-1);
        },
        shareClose () {
            this.copyText(this.copyValue)
            this.showShare = false
        },
        getData () {
            this.isLoading = true
            let url = API_URL_HD_API + '/summer/tea/get_class_completion/'
            let params = {
                summer_year: this.summer_year,
                unit_class_id: this.unit_class_id, // 页码 
                sid: this.sid  //每页几条
            }
            this.$http.post(url, params).then(res => {
                this.isLoading = false
                if (res.data.response === 'ok') {
                    this.stu_data=res.data.data.stu_data
                    this.unit_name =res.data.data.unit_name
                    this.wap_id =res.data.data.wap_id
                }
            })
        },
        share () {
            let wap_url = `${VUE_URL_HD}/#/activity/2023summer/finishdetail/${this.sid}/${this.unit_class_id}?&summer_year=${this.summer_year}`
            this.$http.post(API_URL_SORT_API + '/create_sort/', {
                url: wap_url,
                sort_type: 1
            }).then((res) => {
                if (res.data.response === 'ok') {
                    let short_url=res.data.data.short_url
                    if (this.inApp) {
                        let title = this.unit_name + "完成情况";
                        let content = `${this.unit_name}${this.sid == 51 ? '语文' : '数学'}暑假作业完成情况`;
                        this.appFunction("ys_share", `${title},${content},${short_url},2,${this.unit_class_id},0,26,暑假作业活动分享`);
                    } else {
                        let coptText = `${this.unit_name}暑假作业完成情况，链接：${short_url}`
                        this.copyValue = coptText
                        this.showShare = true
                    }
                }
                
            })
            

        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    }
}
</script>

<style lang="scss" scoped>
.detail_page {
    min-height: 100vh;
    background: #f3f3f3;
    padding-top: 96px/$ppr;
    padding-bottom: 140px/$ppr;
}

.herder {
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    background: #ffffff;
    position: fixed;
    z-index: 9;
    top: 0;
    left: 0;
    width: 100%;

    .back {
        width: 64px / $ppr;
        height: 96px / $ppr;
        display: inline-block;
        position: absolute;
        text-align: center;
        top: 0;
        left: 0;
        z-index: 3;

        i {
            width: 16px / $ppr;
            height: 30px / $ppr;
            background: url("./img/icon_img_23.png") no-repeat;
            background-size: 100% 100%;
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    p {
        width: 100%;
        text-align: center;
        height: 96px / $ppr;
        display: inline-block;
        font-size: 36px / $ppr;
        color: #333333;
    }
}

.title {
    padding: 50px/$ppr 24px/$ppr 46px/$ppr;
    font-size: 32px/ $ppr;
    color: #333;
    font-weight: bold;
    display: flex;
    align-items: center;

    .icon {
        width: 36px/$ppr;
        height: 36px/$ppr;
        background: url("./img/icon_detail.png");
        background-size: 36px/$ppr 36px/$ppr;
        margin-right: 10px/$ppr;
       
    }
}

.stu_list {
    padding: 0 24px/$ppr;

    .item {
        background: #fff;
        border-radius: 20px/$ppr;
        padding: 15px/$ppr 25px/$ppr 10px/$ppr;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px/$ppr;
        .name {
            display: flex;
            align-items: center;
            width: 150px/$ppr;

            .avatar {
                width: 56px/$ppr;
                height: 56px/$ppr;
                border-radius: 100%;
                margin-right: 10px/$ppr;
            }

            p {
                font-size: 28px/$ppr;
                color: #333;
            }
        }

        .test_list {
            flex: 1;
            margin-left: 30px/$ppr;
            display: flex;
            flex-wrap: wrap;

            .test_item {
                flex: 0 0 30.33333%;
                padding: 18px/$ppr 0;
                background-color: #f0f4fe;
                background: -webkit-linear-gradient(to bottom, #fff 0%, #f0f4fe 100%);
                margin: 20px/$ppr 0 20px/$ppr 3%;

                strong {
                    display: block;
                    font-weight: bold;
                    text-align: center;
                    font-size: 36px/$ppr;
                    color: #5e89ef;
                }

                p {
                    text-align: center;
                    font-size: 22px/$ppr;
                    color: #333;
                }
            }
        }
        .no_join{
            font-size: 28px/$ppr;
            color: #999;
            font-weight: bold;
            text-align: center;
            line-height: 147px/$ppr;
            flex: 1;
            margin-left: 30px/$ppr;
        }
    }
}

//活动规则弹窗
.active-rule-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);

    .rule-content {
        box-sizing: border-box;
        width: 672px / $ppr;
        padding: 0 35px / $ppr 30px / $ppr 45px / $ppr;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        position: relative;
        border-radius: 20px/$ppr;

    }
}

.share_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 65px/$ppr 0 27px/$ppr;
    img {
        display: block;
        margin: 0 auto 5px/$ppr;
        width: 331px/$ppr;
        height: 250px/$ppr;
    }

    strong {
        font-size: 34px/$ppr;
        color: #223f68;
        font-weight: bold;
        margin-bottom: 13px/$ppr;
    }

    p {
        font-size: 26px/$ppr;
        color: #959ca4 !important;
        margin-bottom: 70px/$ppr !important;
        padding: 0 35px/$ppr !important;
        span {
            font-size: 32px/$ppr;
            color: #4d8cff;
            font-weight: bold;
        }
    }

    .btn {
        display: block;
        font-size: 30px/$ppr;
        color: #fff;
        line-height: 80px/$ppr;
        border-radius: 40px/$ppr;
        padding: 0 140px/$ppr;
        background-color: #5dcffc;
        background: -o-linear-gradient(to right, #5dcffc 0%, #4a82ff 100%);
        background: -ms-linear-gradient(to right, #5dcffc 0%, #4a82ff 100%);
        background: linear-gradient(to right, #5dcffc 0%, #4a82ff 100%);
        background: -moz-linear-gradient(to right, #5dcffc 0%, #4a82ff 100%);
        background: -webkit-linear-gradient(to right, #5dcffc 0%, #4a82ff 100%);
    }
}

.fixed_bottom{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 1px / $ppr solid #f3f3f3;
    padding: 30px/$ppr 24px/$ppr;
    background-color: #fff;
    text-align: center;
    box-sizing: border-box;
    .share_btn {
        display: block;
        width: 100%;
        height: 80px / $ppr;
        background-color: #5e89ef;
        color: #fff;
        font-size: 28px / $ppr;
        border: none;
        border-radius: 40px / $ppr;
        margin: 0 auto;
        line-height: 80px/$ppr;
    }
}
.share-box{
    width: 600px/$ppr !important;
}
</style>
